export const environment = {
    production: true,
    rootPath: '/api',
    domainPrefix: '',
    copyright: '© $YEAR$ Astolia S.r.l.',
    address: '',
    forbiddenWords: ['admin', 'default', 'member', 'root', 'test', 'user']
};
